<!--
 * @Author: lc
 * @Date: 2022-04-09 15:28:15
 * @LastEditors: lc
 * @LastEditTime: 2022-08-30 17:21:56
 * @Description: 
-->
<template>
  <div class="config">
    <Form ref="configData"
          :model="config"
          action="javascript:void(0)">
      <FormItem label="锦盒商城分享标题">
        <Input v-model="config.shop_share_title"></Input>
      </FormItem>
      <!-- <FormItem label="锦盒商城分享描述">
        <Input type="textarea"
               v-model="config.shop_share_describe"></Input>
      </FormItem> -->
      <FormItem label="锦盒商城分享封面图">
        <upload-thumb v-model="config.shop_share_thumb"
                      ref="uploadthumb"
                      :defaultList="thumblist"
                      :autoCropWidth="320"
                      :autoCropHeight="320"
                      :defaultTip="'图片格式:jpg、png,建议图片尺寸:320*320,大小不超过2M'"></upload-thumb>
      </FormItem>
      <FormItem>
        <Button type="primary"
                @click="handleSubmit('configData')">提交</Button>
      </FormItem>
    </Form>
  </div>
</template>


<script>
import UploadThumb from "../../common/thumb";

export default {
  name: "config",
  data () {
    return {
      config: {
        shop_share_title: "",
        shop_share_describe: ""
      },
      thumblist: [],
    };
  },
  created: function () {
    this.getConfig();
  },
  components: {
    UploadThumb,
  },
  methods: {
    handleSubmit (name) {
      if (this.$refs["uploadthumb"].uploadList.length > 0) {
        this.config.shop_share_thumb = this.$refs["uploadthumb"].uploadList[0].url;
      }
      this.$api.mangheset.edit(this.config).then(res => {
        if (res.code == 200) {

          this.$Message.success("修改成功...");
        }
      });
    },
    getConfig: function () {
      this.$api.mangheset.detail().then(res => {
        if (res.result) {
          this.config = res.result.config;
          //处理thumb
          if (this.config.shop_share_thumb != null && this.config.shop_share_thumb != "") {
            this.thumblist.push({
              name: this.config.shop_share_thumb,
              url: this.config.shop_share_thumb,
              status: "finished"
            });
          }
        }
      });
    }
  }
};
</script>
